import styled from 'styled-components';

const Button = styled.button`
  cursor: pointer;
  background: none;
  border: none;
  text-decoration: underline;
`;

export const ButtonWrapper = styled.div`
  margin: 24px 0;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  white-space: nowrap;
`;
export default Button;
